import classNames from 'classnames';
import { InputHTMLAttributes } from 'react';

import './radio.css';

interface MRadioProps extends InputHTMLAttributes<HTMLInputElement> {
  id: string;
  value?: string | number;
  checked?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  className?: string;
  labelText?: string;
}
const MRadio: React.FC<MRadioProps> = (props) => {
  const { className, id, labelText = '', ...restProps } = props;
  return (
    <div className={classNames('radio', className)}>
      <input id={id} type="radio" {...restProps} />
      <label htmlFor={id}>{labelText}</label>
    </div>
  );
};

export default MRadio;
